module.exports = __webpack_public_path__ + "assets/img/nW2.59093c21.jpg";